export enum InputTypeEnum {
  RADIO = 'radio',
  TEXT = 'text',
  DROPDOWN = 'dropdown',
  PASSWORD = 'password',
  EMAIL = 'email',
  NUMBER = 'number',
  FILE = 'file',
  CHECKBOX = 'checkbox',
  CARD_RADIO_BUTTON = 'card_radio_button',
  SELECT = 'select',
}
